import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import { f as a } from "./index-LyFokDcn.mjs";
import { L as M } from "./layout-box-DFBM-kSI.mjs";
import f, { isValidElement as A, useCallback as J } from "react";
import { T as q } from "./tooltip-Cy1xtUCm.mjs";
import { m as C } from "./tss-DN0acMKN.mjs";
import { I as K } from "./icon-v2-DGtVEk7e.mjs";
import { M as U, d as X } from "./constants-CnFYFetN.mjs";
import { D as Y } from "./divider-Dq5lrAFK.mjs";
import { T as _ } from "./text-button-yPCa43NP.mjs";
import { B as E } from "./button-CUHBhgeQ.mjs";
const z = (r) => f.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 11 11", width: "11", height: "11" }, r),
  f.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    f.createElement("path", { d: "M10.7939932,2.04027025 L5.22747911,11 L0.544519321,7.6492814 C-0.0176313849,7.24798203 -0.169167662,6.43358036 0.206006831,5.83031987 C0.57873719,5.22837081 1.33641858,5.06312989 1.90101342,5.46705214 L4.55045413,7.36207694 L8.76047409,0.584576458 C9.13442652,-0.0173725985 9.89088584,-0.182613516 10.4554807,0.221308727 C11.0176314,0.622608098 11.1691677,1.43700976 10.7939932,2.04027025 Z" })
  )
);
z.displayName = "Check11x11";
const S = (r) => f.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 28 28", width: "28", height: "28" }, r),
  f.createElement("path", { fillRule: "evenodd", d: "M14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM14 7C13.448 7 13 7.448 13 8H12.999V15C12.999 15.553 13.447 16 13.999 16H14C14.552 16 15 15.552 15 15V8C15 7.44702 14.552 7 14 7ZM14 20.9997C13.172 20.9997 12.5 20.3277 12.5 19.4997C12.5 18.6717 13.172 17.9997 14 17.9997C14.828 17.9997 15.5 18.6717 15.5 19.4997C15.5 20.3277 14.828 20.9997 14 20.9997Z", clipRule: "evenodd" })
);
S.displayName = "ExclamationCircle28x28";
const T = (r) => f.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 10 12", width: "10", height: "12" }, r),
  f.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    f.createElement(
      "g",
      null,
      f.createElement("path", { d: "M1320.25,99 L1320.25,97.75 C1320.25,95.6789322 1320.92893,95 1323,95 C1325.07107,95 1325.75,95.6789322 1325.75,97.75 L1325.75,99 L1326,99 C1327.10457,99 1328,99.8954305 1328,101 L1328,105 C1328,106.104569 1327.10457,107 1326,107 L1320,107 C1318.89543,107 1318,106.104569 1318,105 L1318,101 C1318,99.8954305 1318.89543,99 1320,99 L1320.25,99 Z M1321.75,99 L1324.25,99 L1324.25,97.75 C1324.25,96.5073593 1324.24264,96.5 1323,96.5 C1321.75736,96.5 1321.75,96.5073593 1321.75,97.75 L1321.75,99 Z M1323,104 C1323.82843,104 1324.5,103.552285 1324.5,103 C1324.5,102.447715 1323.82843,102 1323,102 C1322.17157,102 1321.5,102.447715 1321.5,103 C1321.5,103.552285 1322.17157,104 1323,104 Z", transform: "translate(-1318 -95)" })
    )
  )
);
T.displayName = "Lock10x12";
const P = C()(({ mode: r, palette: e, spacing: i }) => ({
  /* @startCleanup encore */
  root: {
    backgroundColor: e.gray[100],
    borderRadius: "8px",
    boxSizing: "border-box",
    outline: r === U.Dye ? `1px solid ${X.main}` : void 0,
    width: "330px"
  },
  /* @endCleanup encore */
  steps: {
    display: "grid",
    /* @startCleanup encore */
    padding: a.ifFeature("encore", void 0, `${i(2.5)} ${i(3)} ${i(2.5)} ${i(1.5)}`),
    /* @endCleanup encore */
    rowGap: a.ifFeature("encore", i(0.5), "2px")
  },
  navigation: {
    borderTop: a.ifFeature("encore", void 0, `1px solid ${e.gray[300]}`),
    margin: `0 ${i(3)}`,
    padding: a.ifFeature("encore", void 0, `${i(2.5)} 0`)
  }
}));
function H({ biId: r, children: e, steps: i, ...o }) {
  const { classes: t } = P();
  return a.ifFeature(
    "encore",
    /* @__PURE__ */ n.jsxs(M, { biId: r, boxSizing: "border-box", "data-fabric-component": o["data-fabric-component"], width: "330px", children: [
      /* @__PURE__ */ n.jsx("ol", { className: t.steps, children: i }),
      /* @__PURE__ */ n.jsx(Y, { color: "neutral-extra-weak", margin: 3 }),
      /* @__PURE__ */ n.jsx("div", { className: t.navigation, children: e })
    ] }),
    /* @__PURE__ */ n.jsxs("div", { className: t.root, "data-bi-id": r, "data-fabric-component": o["data-fabric-component"], children: [
      /* @__PURE__ */ n.jsx("ol", { className: t.steps, children: i }),
      /* @__PURE__ */ n.jsx("div", { className: t.navigation, children: e })
    ] })
  );
}
const ee = C()(({ spacing: r }) => ({
  navigation: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    /* @startCleanup encore */
    "& > :nth-child(2)": {
      alignSelf: a.ifFeature("encore", void 0, "center")
    },
    /* @endCleanup encore */
    rowGap: a.ifFeature("encore", r(2), r(1.5))
  }
}));
function V({ nextButton: r, prevButton: e, cancelButton: i }) {
  const { classes: o } = ee();
  return /* @__PURE__ */ n.jsxs("div", { className: o.navigation, children: [
    r,
    e,
    i
  ] });
}
var h = /* @__PURE__ */ ((r) => (r.error = "error", r.success = "success", r))(h || {});
const re = C()(({ mixins: r, palette: e, spacing: i, typography: o, constructs: t, borderRadiuses: d }, u, l) => ({
  root: {
    borderRadius: a.ifFeature("encore", d[400], "4px"),
    listStyleType: "none",
    [`&:hover:not(.${l.disabled})`]: {
      backgroundColor: a.ifFeature("encore", t.surface.neutral.forcedWhite, e.common.white),
      /* @startCleanup encore */
      [`&:not(.${l.active}):not(.${l.error}):not(.${l.success}) .${l.iconWrapper}`]: {
        backgroundColor: e.gray[100]
      }
      /* @endCleanup encore */
    }
  },
  button: {
    alignItems: "center",
    backgroundColor: "transparent",
    border: 0,
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    fontFamily: "inherit",
    gap: i(1.5),
    height: "100%",
    outline: "transparent",
    padding: a.ifFeature("encore", i(2), `${i(1)} ${i(1.5)}`),
    width: "100%",
    /* @startCleanup encore */
    "&:focus": {
      boxShadow: a.ifFeature("encore", void 0, `0 0 0 2px ${r.alpha(t.surface.primary.weak, 0.35)}`)
    },
    /* @endCleanup encore */
    "&:disabled": {
      cursor: "default"
    }
  },
  /* @startCleanup encore */
  iconWrapper: {
    alignItems: "center",
    border: `2px solid ${e.gray[700]}`,
    borderRadius: "50%",
    boxSizing: "border-box",
    display: "flex",
    fill: e.gray[700],
    flexShrink: 0,
    height: "28px",
    justifyContent: "center",
    width: "28px"
  },
  /* @endCleanup encore */
  title: {
    color: a.ifFeature("encore", t.text.neutral.strong, e.gray[900]),
    flex: "1 1 auto",
    fontSize: o.large.fontSize,
    fontWeight: o.fontWeightMedium,
    lineHeight: o.large.lineHeight,
    textAlign: "start"
  },
  note: {
    color: a.ifFeature("encore", t.text.neutral.strong, e.gray[700]),
    flex: "0 1 auto",
    fontSize: o.teenie.fontSize,
    lineHeight: o.teenie.lineHeight
  },
  active: {
    backgroundColor: a.ifFeature("encore", t.surface.neutral.forcedWhite, e.common.white),
    /* @startCleanup encore */
    [`& .${l.iconWrapper}`]: {
      borderColor: e.primary.main
    },
    /* @endCleanup encore */
    [`& .${l.title}`]: {
      color: a.ifFeature("encore", t.text.primary.strong, e.primary.main),
      fontWeight: o.fontWeightBold
    }
  },
  disabled: {
    /* @startCleanup encore */
    [`& .${l.iconWrapper}`]: {
      backgroundColor: "transparent",
      borderColor: e.gray[600],
      fill: e.gray[600]
    },
    /* @endCleanup encore */
    [`& .${l.title}`]: {
      color: a.ifFeature("encore", t.text.neutral.xWeak, e.gray[700])
    },
    [`& .${l.note}`]: {
      color: a.ifFeature("encore", t.text.neutral.weak, e.gray[700])
    }
  },
  error: {
    /* @startCleanup encore */
    [`& .${l.iconWrapper}`]: {
      backgroundColor: e.common.white,
      border: "none",
      fill: e.error.main
    },
    /* @endCleanup encore */
    [`& .${l.title}`]: {
      color: a.ifFeature("encore", t.text.error.strong, e.error.main),
      fontWeight: a.ifFeature("encore", void 0, o.fontWeightSemibold)
    },
    /* @startCleanup encore */
    [`& .${l.hideIcon}`]: {
      backgroundColor: "transparent",
      border: `2px solid ${e.error.main}`
    }
    /* @endCleanup encore */
  },
  /* @startCleanup encore */
  hideIcon: {},
  /* @endCleanup encore */
  success: {
    /* @startCleanup encore */
    [`& .${l.iconWrapper}`]: {
      backgroundColor: e.primary.main,
      borderColor: e.primary.main,
      fill: e.common.white
    },
    /* @endCleanup encore */
    [`& .${l.title}`]: {
      color: a.ifFeature("encore", t.text.primary.strong, e.gray[1e3]),
      fontWeight: a.ifFeature("encore", void 0, o.fontWeightSemibold)
    }
  }
})), oe = (r, e, i, o) => o ? null : r && A(r) ? r : e === h.success ? /* @__PURE__ */ n.jsx(z, {}) : e === h.error ? /* @__PURE__ */ n.jsx(S, {}) : i ? /* @__PURE__ */ n.jsx(T, {}) : null, ie = (r, e, i, o, t) => {
  let d = "neutral-extra-strong", u = "circle-regular";
  if (o && (d = "neutral-medium"), r && (d = "primary-strong"), i === h.error && (d = "error-strong", u = "circle-exclamation-solid"), i === h.success && (d = "primary-strong", u = "circle-check-solid"), e) {
    if (typeof e != "string")
      return null;
    u = e;
  }
  return t && (u = "circle-regular"), /* @__PURE__ */ n.jsx(K, { color: d, name: u, size: 32 });
};
function Z({
  active: r,
  biId: e,
  children: i,
  disabled: o,
  hideIcon: t,
  icon: d,
  note: u,
  onClick: l,
  status: m,
  TooltipProps: g
}) {
  const { classes: c, cx: v } = re(), s = J(() => a.ifFeature(
    "encore",
    ie(r, d, m, o, t),
    oe(d, m, o, t)
  ), [r, m, o, t, d]), b = /* @__PURE__ */ n.jsxs(
    "button",
    {
      "aria-disabled": o,
      className: c.button,
      disabled: o && !g,
      onClick: () => o || l == null ? void 0 : l(),
      type: "button",
      children: [
        a.ifFeature(
          "encore",
          s(),
          /* @__PURE__ */ n.jsx("span", { className: t ? `${c.iconWrapper} ${c.hideIcon}` : c.iconWrapper, children: s() })
        ),
        /* @__PURE__ */ n.jsx("span", { className: c.title, children: i }),
        u ? /* @__PURE__ */ n.jsx("span", { className: c.note, children: u }) : null
      ]
    }
  );
  return /* @__PURE__ */ n.jsx(
    "li",
    {
      className: v(c.root, {
        [c.active]: r,
        [c.disabled]: o,
        [c.error]: m === h.error,
        [c.success]: m === h.success
      }),
      "data-bi-id": e,
      children: g ? /* @__PURE__ */ n.jsx(q, { ...g, children: b }) : b
    }
  );
}
function y({
  biId: r,
  currentStep: e,
  NextButtonProps: i,
  nextButtonText: o,
  onNextClick: t,
  onPrevClick: d,
  onCancelClick: u,
  onStepClick: l,
  PrevButtonProps: m,
  prevButtonText: g,
  CancelButtonProps: c,
  cancelButtonText: v,
  steps: s
}) {
  var w, F, W, k, B, N, L, R;
  const b = e > 0, D = (w = s[e + 1]) == null ? void 0 : w.disabled, j = (F = s[e - 1]) == null ? void 0 : F.disabled, G = e === s.length - 1, Q = window.jQuery ? $.__("Next: %s", (W = s[e + 1]) == null ? void 0 : W.title, { note: "The placeholder is the name of the next step in a process" }) : `Next: ${(k = s[e + 1]) == null ? void 0 : k.title}`, O = window.jQuery ? $.__("Save and Finish") : "Save and Finish", I = s.map((x, p) => /* @__PURE__ */ n.jsx(
    Z,
    {
      active: p === e,
      biId: r ? `${r}-step-${p}` : void 0,
      disabled: x.disabled,
      hideIcon: x.hideIcon,
      icon: x.icon,
      note: x.note,
      onClick: () => {
        l == null || l(p);
      },
      status: x.status,
      TooltipProps: x.TooltipProps,
      children: x.title
    },
    x.title
  ));
  return /* @__PURE__ */ n.jsx(H, { biId: r, "data-fabric-component": "VerticalWizard", steps: I, children: /* @__PURE__ */ n.jsx(
    V,
    {
      cancelButton: u ? /* @__PURE__ */ n.jsx(M, { alignSelf: "center", children: /* @__PURE__ */ n.jsx(
        _,
        {
          color: "secondary",
          "data-bi-id": r ? `${r}-cancel-button` : void 0,
          onClick: u,
          type: "button",
          ...c,
          children: v || (window.jQuery ? $.__("Cancel") : "Cancel")
        }
      ) }) : void 0,
      nextButton: /* @__PURE__ */ n.jsx(
        E,
        {
          "data-bi-id": r ? `${r}-next-button` : void 0,
          disabled: D,
          onClick: t,
          size: a.ifFeature("encore", void 0, "biggie"),
          type: "button",
          ...i,
          children: o || (G ? O : Q)
        }
      ),
      prevButton: b ? a.ifFeature(
        "encore",
        /* @__PURE__ */ n.jsx(
          E,
          {
            color: "secondary",
            "data-bi-id": r ? `${r}-prev-button` : void 0,
            disabled: j,
            onClick: d,
            type: "button",
            variant: "outlined",
            ...m,
            children: g || (window.jQuery ? $.__("« Back to %s", (B = s[e - 1]) == null ? void 0 : B.title, {
              note: "The placeholder is the name of the previous step in a process"
            }) : `« Back to ${(N = s[e - 1]) == null ? void 0 : N.title}`)
          }
        ),
        /* @__PURE__ */ n.jsx(
          _,
          {
            color: "secondary",
            "data-bi-id": r ? `${r}-prev-button` : void 0,
            disabled: j,
            onClick: d,
            size: "small",
            type: "button",
            ...m,
            children: g || (window.jQuery ? $.__("« Back to %s", (L = s[e - 1]) == null ? void 0 : L.title, {
              note: "The placeholder is the name of the previous step in a process"
            }) : `« Back to ${(R = s[e - 1]) == null ? void 0 : R.title}`)
          }
        )
      ) : void 0
    }
  ) });
}
y.Base = H;
y.Navigation = V;
y.Step = Z;
export {
  y as V
};
//# sourceMappingURL=vertical-wizard-fUrQDv8b.mjs.map
